










import { computed, defineComponent } from "@vue/composition-api";
import { UserPublicData } from "@scrile/api-provider/dist/api/UserPublicDataProvider";
import { Appointment, AppointmentStatus } from "@scrile/api-provider/dist/projects/scrileConnect/AppointmentProvider";
import { $t } from "@/lib/i18nHelpers";
import { getProfileUrl } from "@/lib/urlHelpers";
import AppointmentsItemView from "../AppointmentsItemView";
import { MenuItem } from "../AppointmentsItemView/AppointmentsItemView.vue";

export default defineComponent({
  name: "AppointmentsItemUpcomingView",
  components: { AppointmentsItemView },
  props: {
    item: { type: Object as () => Appointment, required: true },
    authUserId: { type: String, required: true },
  },
  setup(props, { root, emit }) {
    const opponent = computed<UserPublicData>(() =>
      props.authUserId === props.item.consumerId ? props.item.provider : props.item.consumer
    );

    const menuItems = computed<MenuItem[]>(() => [
      ...([AppointmentStatus.APPROVED].includes(props.item.status)
        ? [
            {
              name: "calendar",
              text: $t("Add to calendar"),
              click: () => emit("addToCalendar"),
            },
          ]
        : []),
      {
        name: "messages",
        text: $t("Send message"),
        click: () => {
          root.$router.push({ name: "messages", params: { userId: opponent.value.id } });
        },
      },
      {
        name: "profile",
        text: $t("Go to profile"),
        click: () => {
          root.$router.push(getProfileUrl(opponent.value));
        },
      },
      ...([AppointmentStatus.APPROVED, AppointmentStatus.NEW].includes(props.item.status)
        ? [
            {
              name: "cancel",
              text: $t("Cancel"),
              click: () => emit("cancel"),
            },
          ]
        : []),
      ...([AppointmentStatus.CANCELLED, AppointmentStatus.REJECTED].includes(props.item.status)
        ? [
            {
              name: "remove",
              text: $t("Remove"),
              click: () => emit("remove"),
            },
          ]
        : []),
    ]);

    return {
      menuItems,
    };
  },
});
